import { useQuery } from '@apollo/client';
import {
    CITRIN_GET_TRIPS_RIDER_HISTORY,
    GetTripsHistoryRIDERIdRequest,
    GetTripsHistoryRIDERIdResponse,
} from '../index';
import { TripsHistoryFetchInputMgt } from '../../shared/types';

export const useGetTripsHistoryByRiderIdQuery = (request: TripsHistoryFetchInputMgt) => {
    const { data, previousData, error, loading, ...rest } = useQuery<
        GetTripsHistoryRIDERIdResponse,
        GetTripsHistoryRIDERIdRequest
    >(CITRIN_GET_TRIPS_RIDER_HISTORY, {
        variables: { request },
        skip: !request?.id,
        fetchPolicy: 'cache-and-network',
        // onCompleted: (data) => console.log('[MGT] Riders', data),
        // onError: (error) => console.error('Error fetching invoices history:', error),
    });

    return {
        ...rest,
        loading,
        data: data?.CITRIN_MGT_getTripsHistoryByRiderId,
        previousData: previousData?.CITRIN_MGT_getTripsHistoryByRiderId,
    };
};
